import { render, staticRenderFns } from "./core.vue?vue&type=template&id=66b82d56&scoped=true&"
import script from "./core.vue?vue&type=script&lang=js&"
export * from "./core.vue?vue&type=script&lang=js&"
import style0 from "./core.vue?vue&type=style&index=0&id=66b82d56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b82d56",
  null
  
)

export default component.exports